
	import Vue, { PropType } from 'vue';
	import Component from 'vue-class-component';

	import formatDate from '@/services/Formatter/DateFormatter';
	import { ValuesHeaderMapping } from '@/types';
	import { CellTypeEnum } from '@/types/enum/CellTypeEnum';

	export type CellType = CellTypeEnum.date | CellTypeEnum.period | CellTypeEnum.chip | CellTypeEnum.money | CellTypeEnum.distance | CellTypeEnum.percentage;

	const Props = Vue.extend({
		props: {
			value: {
				type: [String, Number, Array, Object],
				required: false,
				default: ''
			},
			cellType: {
				type: String as PropType<CellType>,
				required: true
			},
			colors: {
				type: [Array, Object],
				required: false,
				default: () => [] as ValuesHeaderMapping[]
			}
		}
	});

	/** One cell of the TableBuilder */
	@Component
	export default class CellFormatter extends Props {
		// Stronger types
		cellType!: CellType;

		formatDate = formatDate;

		get capitalize() {
			return this.value.charAt(0).toUpperCase() + this.value.slice(1);
		}

		get tooltipText() {
			const tooltipText = this.colors.find((valueTooltipText: ValuesHeaderMapping) => {
				return valueTooltipText.label === this.value;
			}) as ValuesHeaderMapping;

			return tooltipText ? tooltipText.tooltipText : '';
		}

		getColor(value: string): string {
			const color = this.colors.find((valueColor: ValuesHeaderMapping) => {
				return valueColor.label === value;
			}) as ValuesHeaderMapping;

			return color ? color.color : '';
		}

		formatMoney(value: number): string {
			if (null === value) {
				return '-';
			}

			return (new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(value));
		}

		formatPercentage(value: number): string {
			if (isNaN(+value)) {
				value = 0;
			}

			return value + ' %';
		}

		formatDistance(value: string): string {
			return isNaN(+value) ? '0 km' : value + ' km';
		}

		formatArray(array: string []): string {
			return array.join(', ');
		}
	}
